// extracted by mini-css-extract-plugin
export default {"controlBox":"_ControlBoxJustified_controlBox__E0toE","right":"_ControlBoxJustified_right__8MDCT"};